import Router from '../Router';
import { RankingsController } from '../../controllers';

export class Rankings extends Router {
	initialize( options ) {
		this.typeMenu   = 'rankings';
		this.controller = new RankingsController( options );
	}

	get appRoutes() {
		return {
			'rankings/tipping': 'rankingsTipping',
			'rankings/comp':    'rankingsComp',
			'rankings/streak':  'rankingsStreak'
		};
	}
}
export default Rankings;